import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import useScrollLock from '../../hooks/useScrollLock';
import './EditProfileModal.css';

const EditProfileModal = ({ isOpen, onClose }) => {
  const { currentUser, updateProfile } = useAuth();
  const { t } = useLanguage();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useScrollLock(isOpen);

  useEffect(() => {
    if (isOpen) {
      setFirstName(currentUser?.firstName || '');
      setLastName(currentUser?.lastName || '');
      setError('');
    }
  }, [isOpen, currentUser]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !lastName.trim()) {
      setError(t('navigation.nameRequired'));
      return;
    }
    setSaving(true);
    setError('');
    const result = await updateProfile(firstName.trim(), lastName.trim());
    setSaving(false);
    if (result.success) {
      onClose();
    } else {
      setError(result.error || t('navigation.failedToUpdateName'));
    }
  };

  return (
    <div className="edit-profile-overlay">
      <div className="edit-profile-modal">
        <div className="edit-profile-header">
          <h3>{t('navigation.editProfile')}</h3>
          <button type="button" className="edit-profile-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="edit-profile-body">
            <div className="edit-profile-field">
              <label htmlFor="edit_profile_first_name">{t('auth.firstName')}</label>
              <input
                type="text"
                id="edit_profile_first_name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                maxLength={100}
                autoFocus
              />
            </div>
            <div className="edit-profile-field">
              <label htmlFor="edit_profile_last_name">{t('auth.lastName')}</label>
              <input
                type="text"
                id="edit_profile_last_name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                maxLength={100}
              />
            </div>
            {error && <div className="edit-profile-error">{error}</div>}
          </div>
          <div className="edit-profile-footer">
            <button type="button" className="edit-profile-btn secondary" onClick={onClose} disabled={saving}>
              {t('common.cancel')}
            </button>
            <button type="submit" className="edit-profile-btn primary" disabled={saving}>
              {saving ? `${t('common.save')}...` : t('common.save')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;
